<script>
  import { onMount } from 'svelte';
  import { format } from 'svelte-i18n';
  import { Button, Input } from '@sveltestrap/sveltestrap';

  import { CopyText } from '@client/components/copy-text';
  import { Spinner } from '@client/components/spinner';

  import { SignaturesService } from '@client/services/signatures';

  export let email = '';
  export let parameters = {};
  export let allowCopy = true;
  export let zoomControls = false;

  let recipientEmail = '';
  let signature = {};
  let fetching = false;
  let initialized = false;
  let html = '';
  let zoomLevel = 1;

  const getSignature = async () => {
    const data = {
      username: email,
      params: parameters || {},
      testData: {},
      prependLines: 0
    };

    if (recipientEmail) {
      data.testData.testrecipient = recipientEmail;
    }

    fetching = true;

    const response = await SignaturesService.getSignature(data);
    const rendered = response?.rendered;

    html = rendered;

    fetching = false;

    return rendered;
  };

  const update = async () => {
    signature = await getSignature();
  };

  const resizeIframe = function () {
    const body = this.contentWindow.document.body;
    const content = body.firstChild;

    this.style.visibility = 'visible';
    this.style.height = content.scrollHeight + 40 + 'px';
    this.style.width = content.scrollWidth + 40 + 'px';
  };

  const onPreviewIframeLoad = function (e) {
    resizeIframe.call(this, e, true);
    initialized = true;
  };

  onMount(async () => await update());

  $: zoom = `transform: scale(${zoomLevel}); transform-origin: left top; -moz-transform: scale(${zoomLevel}); -moz-transform-origin: left top;`;
  $: update(parameters);
</script>

<div class="signature-preview">
  {#await signature}
    <div class="section-loading">
      <Spinner show inline backdrop />
    </div>
  {:then signature}
    {#if signature}
      <div class="preview-container">
        <div class="preview-recipient">
          <Input type="text" bind:value={recipientEmail} placeholder={$format('label.ENTER_RECIPIENT_EMAIL')} />
          <Button color="secondary" on:click={update}>{$format('label.PREVIEW')}</Button>
        </div>
        <div class="preview">
          <div class="actions">
            {#if zoomControls}
              <div class="slider">
                <label for="zoom">
                  {#if zoomLevel === 1}
                    {$format('label.ACTUAL_SIZE')}
                  {:else}
                    {$format('label.ZOOM')}
                  {/if}
                  {Math.round(zoomLevel * 100)}%
                </label>
                <input id="zoom" type="range" min="0.25" max="2" step="0.05" bind:value={zoomLevel} />
              </div>
            {/if}
            {#if allowCopy}
              <div class="copy">
                <CopyText label="Copy HTML" source={html} />
              </div>
            {/if}
          </div>

          <iframe
            tabindex="-1"
            style="width: 100%; visibility: hidden;"
            scrolling="yes"
            title="Signature"
            on:load={onPreviewIframeLoad}
            srcdoc={`<html><body><div style="display: inline-block; ${zoom}">${html || ''}</div></body></html>`}
          />
          {#if fetching}
            <Spinner show backdrop />
          {/if}
        </div>
      </div>
    {:else}
      {$format('label.USER_DOES_NOT_BELONG_TO_GROUP')}
    {/if}
  {:catch error}
    <p style="color: red">{error.message}</p>
  {/await}
</div>

<style lang="scss" src="./my-signature.scss"></style>
